import { createSlice } from '@reduxjs/toolkit';
import { Features } from '../../../featureToggles/features';
import { IUpgradeAccountToEnterpriseState } from './interfaces';
import { upgradeAccountToEnterprise } from './thunk';
import { BlockedByFeature, BlockedByFeatureType, notAvailablePropExceptIn } from '../../../featureToggles/features/utils';

export type IUpgradeAccountToEnterpriseStatePlgExternal3 = IUpgradeAccountToEnterpriseState | BlockedByFeatureType;

const initialState: IUpgradeAccountToEnterpriseStatePlgExternal3 = notAvailablePropExceptIn({
  expected: {
    saving: false
  },
  availableIn: [Features.PlgExternal3]
});

const upgradeAccountToEnterpriseSlice = createSlice({
  name: 'upgradeAccountToEnterpriseSlice',
  initialState,
  reducers: {},
  extraReducers: {
    [upgradeAccountToEnterprise?.pending.type]: (state: IUpgradeAccountToEnterpriseStatePlgExternal3): IUpgradeAccountToEnterpriseStatePlgExternal3 => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.saving = true;
      return state;
    },
    [upgradeAccountToEnterprise?.fulfilled.type]: (state: IUpgradeAccountToEnterpriseStatePlgExternal3): IUpgradeAccountToEnterpriseStatePlgExternal3 => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.saving = false;
      return state;
    },
    [upgradeAccountToEnterprise?.rejected.type]: (state: IUpgradeAccountToEnterpriseStatePlgExternal3): IUpgradeAccountToEnterpriseStatePlgExternal3 => {
      if (state === BlockedByFeature) {
        return state;
      }
      state.saving = false;
      return state;
    }
  }
});

export default upgradeAccountToEnterpriseSlice.reducer;